import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import { receiveError, receiveSuccess } from '../../../store/actions/notificationAction';

import DriverETASelectAuto from './DriverETASelectAuto';
import DriverETASelectManually from './DriverETASelectManually';

import { History } from 'history';

import gmapsReqHandler from '../../../api/googleMapsRemote';
import ghaReqHandler from '../../../api/ghaRemote';
import poReqHandler from '../../../api/pickupOrderRemote';

import PickupOrder from '../../../models/PickupOrder';
import ResponseError from '../../../models/ResponseError';
import ApiResponse from '../../../models/ApiResponse';
import GhaModel from '../../../models/Gha';

import MomentUtils from "@date-io/moment";
import moment, { Moment } from 'moment';

import { dayMap } from '../../../utils/dayMap';

import fdTextLogo from '../../../assets/icon_fd_u91.png';

type Type = 'import' | 'export';

interface DriverMapETAProps {
  pickupOrder: PickupOrder;
  secretKey: string;
  receiveSuccess: Function;
  receiveError: Function;
  history: History;
  match: { params: { orderType: string, poNumber: string, secretKey: string } };
};

interface DriverMapETAState {
  loading: boolean;
  userLocation: { lat: number, lng: number } | null;
  destination: { lat: number, lng: number } | null;
  destinationMarkerSVGPath: any;
  positionMarkerSVGPath: any;
  durationValue: number;
  arrivalTime: Date;
  arrivesIn: string;
  selectTime: string;
  selectedValue: number;
  activeStep: number;
  setETAAuto: boolean;
  selectedDate: Moment;
  dock: Array<number>;
  docsLoad: Array<Array<number>>;
  work: Array<{ end: string, start: string }>;
  workingHours: Array<{end: string, start: string }>;
  cams: Array<{ url: string, description: string } | null>
};


class DriverETAContainer extends Component<DriverMapETAProps, DriverMapETAState> {

  state = {
    userLocation: null,
    loading: true,
    destination: null,
    destinationMarkerSVGPath: null,
    positionMarkerSVGPath: null,
    durationValue: 0,
    arrivalTime: new Date(),
    arrivesIn: '',
    selectTime: '',
    selectedValue: -1,
    activeStep: 0,
    setETAAuto: false,
    selectedDate: new MomentUtils().date(),
    docsLoad: [],
    workingHours: [],
    dock: [],
    work: [],
    cams: []
  };

  componentDidMount() {

    this.load(this.props.pickupOrder.id_gha) ;

    // Get current user position
    navigator.geolocation.getCurrentPosition(
      position => {
        const { latitude, longitude } = position.coords;

        // Get geolocation of destination
        gmapsReqHandler.getGeoCode(this.props.pickupOrder.pickup_from.full_address).then((geocodeRes: { data: { error_message: string, results: { geometry: { location: { lat: number, lng: number } } }[], status: string } }) => {
          
          let geocodeData = geocodeRes.data;

          if (geocodeData.error_message) {

            this.props.receiveError({ errorCode: "#couldntLoadGmaps", longDescription: "Couldn't get coordinates of destination." });

          } else {

            let destination: { lat: number, lng: number } = geocodeData.results[0].geometry.location;

            // Calculate distance
            gmapsReqHandler.getDistance(`${latitude}, ${longitude}`, `${destination.lat}, ${destination.lng}`).then((resp: ApiResponse<number>) => {

              const result: number | undefined = resp.result;
              const error: ResponseError | undefined = resp.error;

              if (result) {
                let d: Date = new Date();
                d.setSeconds(d.getSeconds() + result);
                let arrivesIn: string = Math.floor(result / 60 / 60) + ":" + Math.floor(result % 3600 / 60);
                this.setState({ destination, setETAAuto: true, userLocation: { lat: latitude, lng: longitude }, durationValue: result, arrivalTime: d, arrivesIn });
              }

              if (error) {
                this.props.receiveError(error);
              };
            });
          }
        });
      },
      () => {
        this.props.receiveError({ errorCode: "#couldntLoadGmaps", longDescription: "Couldn't get current location." });
      }
    );
  };
  
  componentDidUpdate(prevProps: DriverMapETAProps) {
    if(prevProps !== this.props) {
      
      this.load(this.props.pickupOrder.id_gha);
    } 
  };

  load = (id:number): void => {

    const selectedDate : Moment  = this.props.pickupOrder.pickup_date ? moment(this.props.pickupOrder.pickup_date) : new MomentUtils().date();
    const selectTime: string = this.props.pickupOrder.pickup_time ? `${this.props.pickupOrder.pickup_time.slice(0,2)}.${this.props.pickupOrder.pickup_time.slice(2,4)}` : ''
    const selectedValue: number = this.props.pickupOrder.pickup_time ? Math.floor(+selectTime) : -1;
    this.setState({ selectedDate, selectTime , selectedValue});
    const secretKey: string = this.props.secretKey? this.props.secretKey : '';
 
    ghaReqHandler.getGhaInfo(id, secretKey).then((resp: ApiResponse<GhaModel>) => {

      const gha: GhaModel | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;
      

      if (gha) {

        const workingHours: Array<{ end: string, start: string }> = this.props.pickupOrder.order_type === 'po' ? gha.working_hours['import'] : gha.working_hours['export'];
        const docsLoad: Array<Array<number>> = gha.dock_load;

        const day = this.state.selectedDate.format('ddd');
        const dayWeek: number = dayMap[`${day}`]
       
        const dock: Array<number> = docsLoad[dayWeek];
       
        const work: any = workingHours[dayWeek];
        const cams: Array<{ url:string, description: string } | null> = gha.info.cams ? gha.info.cams : []
        this.setState ({workingHours, docsLoad, dock, work, cams })
      }

      if (error) {
        this.props.receiveError(error);
      };
    });
  };

  setETADriver = (time: string): void => {

    poReqHandler.setETA(this.props.pickupOrder.number, this.props.secretKey, time).then((resp: ApiResponse<boolean>) => {
      
      const success: boolean | undefined = resp.success;
      const error: ResponseError | undefined = resp.error;

      if (success) {
        this.props.receiveSuccess("Successfully set ETA");
        this.returnPage();
      };
      if (error) {
        this.props.receiveError(error);
      };
    })
  };

  setETAAuto = (): void => {

    if (this.props.pickupOrder.id_gha) {

      ghaReqHandler.getGhaTime(this.props.pickupOrder.id_gha, this.state.durationValue).then((resp: ApiResponse<{ date: string, time: string }>) => {
        
        const result: { date: string, time: string } | undefined = resp.result;
        const error: ResponseError | undefined = resp.error;

        if (result) {
          if (result.date !== this.props.pickupOrder.pickup_date) {
            this.props.receiveError({
              errorCode: "#incorrectPickupDate",
              longDescription: "The calculated ETA cannot be accepted, because it is in a date different than “Scheduled Pick Up Date”. Please use the option for manual selection of ETA or, if you need to change the Pick Up Date, contact the Forwarding company."
            });
          } else {
            this.setETADriver(result.time);
          };
        };
        if (error) {
          this.props.receiveError(error);
        };
      });
    };
  };

  setETAManually = (): void => {

    const time: string = this.state.selectTime.replace('.', '');
    this.setETADriver(time);
  };

  returnPage = (): void => {

    const poNumber: string = this.props.pickupOrder.number;
    const secretKey: string = this.props.secretKey;
    const orderType: string = this.props.match.params.orderType;
    
    if (poNumber && secretKey) {
      this.props.history.push(`/${orderType}-drv/${poNumber}/${secretKey}`);
    };
  };

  handleChangeSelectTime = (event: any): void => {

    const selectTime: string = event.target.value;
    const selectedValue: number = Math.floor(+selectTime);

    this.setState({
      selectedValue,
      selectTime 
    });
  }; 

  handleChangeSelectedValue = (event: any): void  => {
   
    const selectedValue: number = +event.target.value;

    let selectTime: string = selectedValue.toFixed(2).toString();
    
    if (selectTime.length === 4 ) {
      selectTime = '0'+ selectTime;
    };
   
    this.setState({ 
      selectTime,
      selectedValue 
    });
  };

  handleNext = (): void => {
  
    const activeStep: number = this.state.activeStep + 1;
    this.setState({ activeStep });
  };

  handleBack = (): void => {
 
    const activeStep: number = this.state.activeStep - 1;
    this.setState({ activeStep });
  };

  handleStepChange = (step: number) => {

    this.setState({ activeStep: step });
  }

  render() {

    return ( 
      <Fragment>
        <DriverETASelectAuto 
          poNumber={ this.props.pickupOrder.number }
          fdTextLogo={ fdTextLogo }
          arrivalTime={ this.state.arrivalTime }
          arrivesIn={ this.state.arrivesIn }
          destination={ this.state.destination }
          userLocation={ this.state.userLocation }
          setETA={ this.setETAAuto }
          setETAAuto={ this.state.setETAAuto }
        />
        <DriverETASelectManually 
          handleChange={ this.handleChangeSelectTime }
          selectTime={ this.state.selectTime }
          selectedValue={ this.state.selectedValue }
          handleChangeSelectedValue={ this.handleChangeSelectedValue }
          setETA={ this.setETAManually }
          activeStep={ this.state.activeStep }
          handleNext={ this.handleNext }
          handleBack={ this.handleBack }
          handleStepChange={ this.handleStepChange }
          dockLoad={ this.state.dock }
          workingHours={ this.state.work }
          cams={ this.state.cams }
          ghaId={ this.props.pickupOrder.id_gha }
        />
      </Fragment>        
    );
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error)),
    receiveSuccess: (message: string) => dispatch(receiveSuccess(message))
  };
};

export default connect(null, mapDispatchToProps)(DriverETAContainer);